import { Instance } from 'mobx-state-tree';
import { DriverInviteAcceptedDtoModelBase } from './DriverInviteAcceptedDtoModel.base';

/* The TypeScript type of an instance of DriverInviteAcceptedDtoModel */
export interface DriverInviteAcceptedDtoModelType extends Instance<typeof DriverInviteAcceptedDtoModel.Type> {}

/* A graphql query fragment builders for DriverInviteAcceptedDtoModel */
export { selectFromDriverInviteAcceptedDto, driverInviteAcceptedDtoModelPrimitives, DriverInviteAcceptedDtoModelSelector } from './DriverInviteAcceptedDtoModel.base';

/**
 * DriverInviteAcceptedDtoModel
 */
export const DriverInviteAcceptedDtoModel = DriverInviteAcceptedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
